import { useDispatch } from 'react-redux';
import { setModalId, usePublicState } from '@/store/slices/publicSlice';
import Search from '@/components/categories/Search';
import { useLazyGetUsersReportFileQuery } from '@/store/services/reports';
import FilterBtn from '../SharedComponents/FilterBtn';
import ExportBtn from '../SharedComponents/ExportBtn';
import { useUsersFilters } from '@/store/slices/reportFiltersSlice';
import FilterModal from './FilterModal';

export function Filters() {
  const dispatch = useDispatch();
  const filters = useUsersFilters();
  const { search } = usePublicState();

  const searchValue = search?.usersReportSearch || '';

  return (
    <div className="flex items-center justify-between flex-col md:flex-row gap-4">
      <Search searchName="usersReportSearch" />

      <div className="flex items-center gap-4">
        <FilterBtn
          onClick={() => {
            dispatch(setModalId({ id: 'USERS_REPORT_MODAL' }));
          }}
        />

        <ExportBtn
          useQueryHook={useLazyGetUsersReportFileQuery}
          filters={{ ...filters, search: searchValue }}
        />
      </div>

      <FilterModal />
    </div>
  );
}
